import FullWidthImageSlider from "../../../../src/components/FullWidthImageSlider";
import Slide from "../../../../src/components/FullWidthImageSlider/Slide";
import * as React from 'react';
export default {
  FullWidthImageSlider,
  Slide,
  React
};